import { Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../AppRoutes";
import { useSearchParams } from "../../../hook/use-search-params";
import { withStatisticWapper } from "../statistics";
import { DatePicker, Spin, Typography } from "antd";
import "./index.scss";
import { usePublishDocumentsInfo } from "../hooks/use-publish-document-info";
import { Moment } from "moment";
type RangeValue = [Moment | null, Moment | null] | null;

export const FeaturedInfo = withStatisticWapper(() => {
  const history = useHistory();
  const { searchParams, replaceSearchParams } = useSearchParams();
  const {
    countExpiredExternalDocument,
    countExpiredInternalDocument,
    countExternalDocument,
    countInternalDocument,
    countValidExternalDocument,
    countValidInternalDocument,
    expiredExternalDocuments,
    expiredInternalDocuments,
    externalDocument,
    internalDocument,
    isLoading,
    validExternalDocuments,
    validInternalDocuments,
    countExpiredSQMSDocument,
    countSQMSDocument,
    countValidSQMSDocument,
    expiredSQMSDocuments,
    sqmsDocument,
    validSQMSDocuments,
  } = usePublishDocumentsInfo();
  const url = Routes.statisticDocumentByViagsPage.path;

  const onInternalDocumentClick = () => {
    history.push(url, {
      documentInfo: internalDocument,
      title: "TÀI LIỆU NỘI BỘ",
    });
  };

  const onExpiredInternalDocumentClick = () => {
    history.push(url, {
      documentInfo: expiredInternalDocuments,
      title: "TÀI LIỆU NỘI BỘ LỖI THỜI",
    });
  };

  const onValidInternalDocumentClick = () => {
    history.push(url, { documentInfo: validInternalDocuments, title: "TÀI LIỆU NỘI BỘ CÒN HIỆU LỰC" });
  };

  const onExternalDocumentClick = () => {
    history.push(url, {
      documentInfo: externalDocument,
      title: "TÀI LIỆU BÊN NGOÀI",
    });
  };

  const onValidExternalDocumentClick = () => {
    history.push(url, {
      documentInfo: validExternalDocuments,
      title: "TÀI LIỆU BÊN NGOÀI CÒN HIỆU LỰC",
    });
  };

  const onExpireExternaldDocumentClick = () => {
    history.push(url, {
      documentInfo: expiredExternalDocuments,
      title: "TÀI LIỆU BÊN NGOÀI LỖI THỜI",
    });
  };

  const onSQMSDocumentClick = () => {
    history.push(url, {
      documentInfo: sqmsDocument,
      title: "TÀI LIỆU SQMS",
    });
  };

  const onValidSQMSDocumentClick = () => {
    history.push(url, {
      documentInfo: validSQMSDocuments,
      title: "TÀI LIỆU SQMS CÒN HIỆU LỰC",
    });
  };

  const onExpiredSQMSDocumentClick = () => {
    history.push(url, {
      documentInfo: expiredSQMSDocuments,
      title: "TÀI LIỆU SQMS LỖI THỜI",
    });
  };

  const handleDateChange = (value: RangeValue) => {
    if (value) {
      const [startDate, endDate] = value;
      searchParams.set("start", startDate?.startOf("month").startOf("day")?.toISOString() || "");
      searchParams.set("end", endDate?.endOf("month").endOf("day")?.toISOString() || "");
      replaceSearchParams(searchParams);
    } else {
      searchParams.delete("start");
      searchParams.delete("end");
      replaceSearchParams(searchParams);
    }
  };

  if (isLoading) return <Spin spinning={true} />;

  return (
    <Col sm={12} md={12}>
      <Col className="py-3 statistic-header">
        <h3>THỐNG KÊ TỔNG THỂ</h3>
        <p>
          <i>Thống kê số lượng triển khai tài liệu/quy trình</i>
        </p>
      </Col>
      <div className="py-2 modal-date-picker d-flex justify-content-end px-3">
        <Typography.Text className="modal-date-text py-2 px-2">Thời gian ban hành/triển khai</Typography.Text>
        <DatePicker.RangePicker
          placeholder={["Ngày bắt đầu", "Ngày kết thúc"]}
          style={{ width: "30%", height: "40px" }}
          onChange={handleDateChange}
          allowClear
        />
      </div>
      <Row className="mx-3">
        <Col className="border">
          <div className="row justify-content-md-center">
            <div
              className="col col-lg-5"
              style={{ cursor: "pointer", paddingTop: "30px", paddingBottom: "30px" }}
              onClick={onInternalDocumentClick}
            >
              <span className="featuredTitle">Tài liệu nội bộ</span>
              <div className="featuredMoneyContainer">
                <span className="featuredMoney text-success">{countInternalDocument} tài liệu</span>
                <span className="featuredMoneyRate"></span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="featuredItem" onClick={onValidInternalDocumentClick}>
              <span className="featuredTitle">Tài liệu hiệu lực</span>
              <div className="featuredMoneyContainer">
                <span className="featuredMoney text-success">{countValidInternalDocument} tài liệu</span>
                <span className="featuredMoneyRate">{/* +10 <ArrowUpward className="featuredIcon"/> */}</span>
              </div>
            </div>

            <div className="featuredItem col" onClick={onExpiredInternalDocumentClick}>
              <span className="featuredTitle">Tài liệu lỗi thời</span>
              <div className="featuredMoneyContainer">
                <span className="featuredMoney text-success">{countExpiredInternalDocument} tài liệu</span>
                <span className="featuredMoneyRate"></span>
              </div>
            </div>
          </div>
        </Col>

        <Col className="ml-4 border">
          <div className="border row justify-content-md-center">
            <div
              className="col col-lg-5"
              style={{ paddingTop: "30px", paddingBottom: "30px", cursor: "pointer" }}
              onClick={onSQMSDocumentClick}
            >
              <span className="featuredTitle">Tài liệu SQMS</span>
              <div className="featuredMoneyContainer">
                <span className="featuredMoney text-primary">{countSQMSDocument} tài liệu</span>
                <span className="featuredMoneyRate"></span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="featuredItem" onClick={onValidSQMSDocumentClick}>
              <span className="featuredTitle">Tài liệu hiệu lực</span>
              <div className="featuredMoneyContainer">
                <span className="featuredMoney text-primary">{countValidSQMSDocument} tài liệu</span>
                <span className="featuredMoneyRate">{/* +10 <ArrowUpward className="featuredIcon"/> */}</span>
              </div>
            </div>

            <div className="featuredItem col" onClick={onExpiredSQMSDocumentClick}>
              <span className="featuredTitle">Tài liệu lỗi thời</span>
              <div className="featuredMoneyContainer">
                <span className="featuredMoney text-primary">{countExpiredSQMSDocument} tài liệu</span>
                <span className="featuredMoneyRate"></span>
              </div>
            </div>
          </div>
        </Col>

        <Col className="ml-4 border">
          <div className="border row justify-content-md-center">
            <div
              className="col col-lg-5"
              style={{ paddingTop: "30px", paddingBottom: "30px", cursor: "pointer" }}
              onClick={onExternalDocumentClick}
            >
              <span className="featuredTitle">Tài liệu bên ngoài</span>
              <div className="featuredMoneyContainer">
                <span className="featuredMoney text-primary">{countExternalDocument} tài liệu</span>
                <span className="featuredMoneyRate"></span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="featuredItem" onClick={onValidExternalDocumentClick}>
              <span className="featuredTitle">Tài liệu hiệu lực</span>
              <div className="featuredMoneyContainer">
                <span className="featuredMoney text-primary">{countValidExternalDocument} tài liệu</span>
                <span className="featuredMoneyRate">{/* +10 <ArrowUpward className="featuredIcon"/> */}</span>
              </div>
            </div>

            <div className="featuredItem col" onClick={onExpireExternaldDocumentClick}>
              <span className="featuredTitle">Tài liệu lỗi thời</span>
              <div className="featuredMoneyContainer">
                <span className="featuredMoney text-primary">{countExpiredExternalDocument} tài liệu</span>
                <span className="featuredMoneyRate"></span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );
});
